import React from 'react'
import { Row, Col } from 'antd'
import './Footer.scss'
import PhoneImg from '../../assets/images/phone.png'
import { getWhatsAppLink } from '../../utils/common'

const Footer = () => {
  return (
    <footer className='footer-container'>
      <div className='footer-inner'>
        <Row gutter={[20, 30]}>
          {/* 联系信息：移动端占满行，桌面端占8列 */}
          <Col xs={24}>
            <h3 className='footer-title'>Contact Us</h3>
            <div className='contact-info'>
              <p className='address'>Whats App: +85257899890, +85257905149</p>
              <p className='address'>Email: shawnamosleyvqga714@gmail.com</p>
              <p className='address'>
                Address: Shop 128, Building IIA, Beibu Gulf International Building Materials Trade City, No. 99,
                Jinhaiwan East Street, Qinnan District, Qinzhou City.
              </p>
              <p className='copyright'>©2026 Fangchenggang Yanxing E-commerce Co., Ltd</p>
            </div>
          </Col>
        </Row>
      </div>
      <a className='footer-logo' href={getWhatsAppLink()} target='_blank'>
        <img src={PhoneImg} alt='Whats App' />
      </a>
    </footer>
  )
}

export default Footer
